import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'

import type { ReactElement } from 'react'

import './index.scss'

interface Props {
  badge?: ReactElement
  date: number
  title: string
}

const BlockItem = ({ badge, date, title }: Props): ReactElement => {
  return (
    <div className="block-item-component">
      <div className="block-item-header">
        {badge ? <div className="block-item-header__badge">{badge}</div> : null}
        <div className="block-item-header__title">{title}</div>
      </div>
      <div className="date">{formatDate(date, DATE_FORMATS.DEFAULT_WITH_HOURS)}</div>
    </div>
  )
}

export default BlockItem
